<p-drawer 
    header="Wallet" 
    (onHide)="onClose.emit()" 
    [visible]="isDialogVisible()"
    position="right" 
    styleClass="!w-full md:!w-80 lg:!w-[30rem]">
    <spike-wallet-form [form]="form"></spike-wallet-form>
    <ng-template #footer>
        <div class="flex gap-4 w-full justify-between">

        @if(formView() || !data()){
        <div class="w-full">
            <p-button (click)="onSaveClicked()" [disabled]="form.invalid" icon="pi pi-save" label="Salva" severity="primary" styleClass="w-full"></p-button>
        </div>
        } @if(!formView()&& data()){
            <div class="flex gap-2">
                <p-button (click)="onDeleteClicked()" icon="pi pi-trash" severity="danger" [outlined]="true"></p-button>
            </div>
            <div class="flex gap-2 w-full justify-end">
                <p-button 
                    class="w-full"
                    styleClass="w-full"
                    (click)="formView.set(true)" 
                    icon="pi pi-pencil" 
                    label="Modifica"
                    severity="secondary">
                </p-button>
            </div>
        }
        </div>
    </ng-template>
</p-drawer>
